import { BiArrowBack, BiLink } from "react-icons/bi";
import Button from "@components/button/Button";
import { CountryAssessments } from "@app/features/other/genericApiSlice";
import { countryHasAssessments, getFlagUrl } from "../utils";

type CountryAssessmentProps = {
  country: CountryAssessments;
  handleBack: () => void;
};

const CountryAssessment = ({ country, handleBack }: CountryAssessmentProps) => {
  const flag = getFlagUrl(country.iso_code);
  const hasAssessments = countryHasAssessments(country);

  return (
    <div className="country-assessment">
      <div className="country-assessment-header">
        <Button className="back-button back-button-top" onClick={handleBack}>
          <BiArrowBack /> Back
        </Button>
        <div className="country-assessment-title-row">
          <div className="country-card-flag small">
            <img src={flag} alt={`${country.name} flag`} />
          </div>
          <h2>{country.name}</h2>
        </div>
      </div>
      <div className="assessment-list">
        {hasAssessments ? country.years.map(({ year, assessments }) => (
          <div className="year-group" key={year}>
            <h3 className="year-title">{year}</h3>
            <div className="assessments-in-year">
              {assessments.map((assessment) => (
                <div className="assessment-item" key={assessment.link}>
                  <a href={assessment.link} target="_blank" rel="noopener noreferrer">
                    <span>{assessment.name}</span>
                    <BiLink />
                  </a>
                </div>
              ))}
            </div>
          </div>
        )) : <p>No assessments found for this country</p>}
      </div>
    </div>
  );
};

export default CountryAssessment;
